import React, { useState, useEffect } from 'react';
import * as Icon from "react-feather";
import { Row, Col, Button, Form, Input, Switch, Modal, Tabs } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import appLoaderAction from '../../redux/action/app-loader-action';
import notifyUtitls from '../../utils/notify-utils';
import constantService from '../../services/constant-service';

const ForgotPasswordDialog = ({ isShow, onCancel, onSubmitComplete }) => {
    const history = useHistory();
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const onSubmit = async () => {
		try {
            dispatch(appLoaderAction.enable());
			const values = await form.validateFields();
			try {
                let bean = {
                    to: values.email
                }
                onCancel();
                await constantService.sendEmailResetPassword(bean);
                notifyUtitls.success('สำเร็จ', 'ส่งอีเมล์เพื่อเปลี่ยนรหัสผ่านสำเร็จ');
                history.replace('/');
                dispatch(appLoaderAction.disale());
            } catch (err) {
                notifyUtitls.error(err);
                dispatch(appLoaderAction.disale());
			}
		} catch (errorInfo) {
            dispatch(appLoaderAction.disale());
			notifyUtitls.warning('แจ้งเตือน', 'โปรดระบุข้อมูลให้ครบถ้วน');
		}
	};

    return (
        <div className="container h-100">
            <div className="title-page">
                <Modal
                    title='ตั้งรหัสผ่านใหม่'
                    centered
                    width={750}
                    visible={isShow}
                    onCancel={onCancel}
                    destroyOnClose
                    footer={[
                        <Button key="submit" type="primary" onClick={onSubmit} >
                            <Icon.Save className="me-2" size={17} /> ส่ง
                        </Button>,
                        <Button key="back" className="btn-gray" onClick={onCancel}>
                            ยกเลิก
                        </Button>,
                    ]}>
                    
                    <Form
                        layout="vertical"
                        name="forgot_password"
                        preserve={false}
                        form={form}
                        initialValues={{status: true}}>
                        <Form.Item
                            label="กรอกอีเมลที่คุณใช้ในการรับลิ้งค์ เพื่อเปลี่ยนรหัสผ่าน"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    type: 'email',
                                },
                            ]}>
                            <Input />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        </div>
    );
}

export default ForgotPasswordDialog;
